__webpack_require__.p = "/telugu-typing/_next/";